import i18n from '@locales/index'
export default [
  {
    name: 'orders',
    title: '訂單管理',
    icon: 'clipboard-list.svg',
    iconSize: '15',
    group: '1',
    description: '瀏覽所有訂單詳情，可編輯狀態與加註。',
  },
  {
    name: 'member',
    title: '會員管理',
    icon: 'address-book.svg',
    iconSize: '18',
    group: '1',
    description: '查詢客戶資訊、預約購買記錄、撰寫通知＆寵物資料以及設定會員等級。',
  },
  {
    name: 'coupon',
    title: '優惠券',
    icon: 'ticket.svg',
    iconSize: '19',
    group: '1',
    description: '設定優惠券、使用紀錄、發送折扣碼簡訊。',
  },
  {
    name: 'prepaid',
    title: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
    icon: 'piggy-bank.svg',
    iconSize: '20',
    group: '1',
    description: `設定${i18n.messages['zh_TW']['prepaid']['BASE']}方案、方案購買紀錄、方案代購。`,
  },
  {
    name: 'deposit',
    title: '儲值點數',
    icon: 'dollar-sign.svg',
    iconSize: '18',
    group: '1',
    description: '設定儲值金方案。',
  },
  {
    name: 'service',
    title: '美容服務',
    icon: (() => {
      if (process.env.VUE_APP_DEV_MODE === 'ipetbooking') {
        return 'scissors.svg'
      }
      if (process.env.VUE_APP_DEV_MODE === 'dingbeauty') {
        return 'service-icon.svg'
      }
    })(),
    iconSize: '18',
    group: '1',
    description: '一般服務＆加購設定、分類設定。',
  },
  {
    name: 'hotel',
    title: '寵物住宿',
    icon: 'hotel.svg',
    iconSize: '18',
    group: '1',
  },
  {
    name: 'daycare',
    title: '安親服務',
    icon: 'daycare.svg',
    iconSize: '18',
    group: '1',
    description: '一般服務＆加購設定、分類設定。',
  },
  {
    name: 'goods',
    title: '商品管理',
    icon: 'scissors.svg',
    iconSize: '18',
    group: '1',
    description: '商品管理',
  },
  {
    name: 'staff',
    title: '人事',
    icon: 'user-clock.svg',
    iconSize: '20',
    group: '1',
    description: '設定人員資料、瀏覽訂單＆接單紀錄。',
  },
  {
    name: 'analytics',
    title: '數據分析',
    icon: 'chart-bar.svg',
    iconSize: '20',
    group: '1',
    description: '各項營運數據統計',
  },
  {
    name: 'products',
    title: '分店設定',
    icon: 'store-alt.svg',
    iconSize: '20',
    group: '1',
    description: '設定分店資訊、營業時間、自訂題目。',
  },
  {
    name: 'settings',
    title: '商店設定',
    icon: 'cog.svg',
    iconSize: '18',
    group: '1',
    description: `商店資訊、通知設定、簡訊發送紀錄、${i18n.messages['zh_TW']['APP_NAME']}訂閱資訊。`,
  },
]
